import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";
import axios from "axios";
import swal from 'sweetalert';
import UseFullPageLoader from "../../FullPageLoader/UseFullPageLoader";

const ForgetPassword = () => {
    document.title = "DirtMap - Forgot Password";


    const history = useHistory();
    const [userInput, setUserInput] = useState({
        email: '',
        error_list: []
    })
    const [loader, showLoader, hideLoader] = UseFullPageLoader();

    const handleInput = (e) => {
        e.persist();
        setUserInput({ ...userInput, [e.target.name]: e.target.value });

    }

    const forgetPassword = (e) => {
        showLoader();
        e.preventDefault();
        const data = {
            email : userInput.email
        }

        axios.get('/sanctum/csrf-cookie').then(response => {
            axios.post(`/api/forget/password`, data).then(res => {
                if (res.data.success === true) {
                    hideLoader();
                    swal("success", res.data.message, "success");
                    history.push(`/login`);
                }
                else {
                    if (res.data.errors) {
                        hideLoader();
                        setUserInput({ ...userInput, error_list: res.data.errors });
                    } else {
                        hideLoader();
                        swal({
                            title: "Error!",
                            text: res.data.message,
                            type: "Error",
                            icon: 'error',
                            confirmButtonText: 'Cool'
                        });
                        history.push(`/forget-password`);
                    }
                }
            });
        });
    }

    return (
        <section className="contentContainer02 registerBlock">
            <div className="container">
                <div className="shadowBox contactForm pb-5">
                    <div className="row">
                        <div className="col-lg-6 col-md-6">
                            <div className="largeSideThumb text-center">
                                <img src={'./frontend/images/register-left-thumb.jpg'} alt=""
                                    className="imgResponsive" />
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6">
                            <form onSubmit={forgetPassword}>
                                <h2 className="mt-3 mb-3">Forgot Password</h2>
                                <div className="customFormRow">
                                    <div className="inputField inputFieldLogin">
                                        <input type="email" name="email" onChange={handleInput} value={userInput.email} id="email" placeholder="Please Enter Your Email" />
                                        <span className="validate-error-message">{userInput.error_list.email}</span>

                                    </div>
                                </div>
                                <div className="customFormRow">
                                    <div className="inputField">
                                        <button className="button customButton01 login-btn active submitButton">Submit</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            {loader}
        </section>
    )
}
export default ForgetPassword;